import { useLazyQuery, useQuery, useMutation } from "@apollo/client/react";import { Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { GET_ALL_MOTIVO_ALTA_PACIENTE, adaptMotivoAltaPacienteArray } from '../../../../data/graphQL/queries/GestionAsistencial/getAllMotivoAltaPaciente';
import { GET_ALL_ESTADO_PACIENTE, adaptEstadoPacienteArray } from '../../../../data/graphQL/queries/GestionAsistencial/getAllEstadoPaciente';
import { GET_PACIENTE_ESTADO, adaptPacienteEstadoArray } from '../../../../data/graphQL/queries/GestionAsistencial/getPacienteEstado';
import { UPDATE_ESTADO_PACIENTE_ASISTENCIAL } from '../../../../data/graphQL/mutations/GestionAsistencial/updateEstadoPaciente';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import toast from 'react-hot-toast';



const ESTADO_PACIENTE_ALTA_ID = 1;
const ESTADO_PACIENTE_SERVICIO_ID = 4;

export const TabEstado = ({
  allowedWrite,
  idPaciente,
  evaluacionSelected,
  getContratos
}) => {

  const [formData, setFormData] = useState({
    fechaEstado: null,
    idEstadoPaciente: 0,
    idMotivoAlta: 0,
    observacion: ''
  });

  const [openModal, setOpenModal] = useState(false);
  const [motivoAlta, setMotivoAlta] = useState([]);
  const [estadoPaciente, setEstadoPaciente] = useState([]);

  const {
    columns,
    rows,
    totalCount,
    loadingHistorial,
    getHistorialPaciente
  } = useGetHistorial(idPaciente);

  const [updateEstadoPaciente] = useMutation(UPDATE_ESTADO_PACIENTE_ASISTENCIAL, {
    variables: {
      input: {
        idPaciente: idPaciente,
        fechaEstado: formData.fechaEstado,
        idEstadoPaciente: formData.idEstadoPaciente,
        idMotivo: formData.idMotivoAlta,
        observacion: formData.observacion
      }
    },
    onCompleted: () => {
      clearForm();
      getContratos({variables: { idPaciente }});
    }
  });

  const { data: dataMotivoAltaPaciente } = useQuery(GET_ALL_MOTIVO_ALTA_PACIENTE);

  useEffect(() => {
    if (!dataMotivoAltaPaciente) return;
    setMotivoAlta(adaptMotivoAltaPacienteArray(dataMotivoAltaPaciente?.allMotivoAltaPaciente));
  }, [dataMotivoAltaPaciente]);

  const { data: dataEstadoPaciente } = useQuery(GET_ALL_ESTADO_PACIENTE);

  useEffect(() => {
    if (!dataEstadoPaciente) return;
      setEstadoPaciente(adaptEstadoPacienteArray(dataEstadoPaciente?.allEstadoPaciente).filter((x) => x.displayName == 'Alta' || x.displayName == 'Suspendido'));
  }, [dataEstadoPaciente]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCloseModal = () => setOpenModal(false);
  const handleOpenModal = () => setOpenModal(true);

  const clearForm = () => {
    setFormData((previousData) => ({
      ...previousData,
      fechaEstado: null,
      idEstadoPaciente: 0,
      idMotivoAlta: 0,
      observacion: ''
    }));
  };

  const handleConsultar = () => {
    handleOpenModal();
    getHistorialPaciente({variables: { idPaciente }});
  };

  const isValid = () => {
    const errorMessages = [];

    if (formData.fechaEstado == null) {
      errorMessages.push('Debe elegir una fecha.\n');
    }
    if (formData.idEstadoPaciente == 0) {
      errorMessages.push('Debe elegir un estado.\n');
    }
    if (formData.idMotivoAlta == 0) {
      errorMessages.push('Debe elegir un motivo.\n');
    }
    if (formData.observacion.length == 0) {
      errorMessages.push('Debe elegir una observacion.\n');
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  const handleGrabar = () => {
    if (isValid()) {
      toast.promise(updateEstadoPaciente(), {
        loading: 'Guardando...',
        success: 'Se actualizó el estado del paciente.',
        error: 'Ocurrió un error.'
      });
    }
  };

  const getValue = useCallback((name) => {
    return formData[name];
  }, [formData]);

  const updatedFields = useMemo(() => {
    return structuredClone(fields).
    map((input) => {
      const updatedInput = { ...input };
      switch (input.name) {
        case 'idMotivoAlta':
          const motivos = motivoAlta?.filter(x => x.displayName?.toLowerCase() !== "forzado por el sistema");
          updatedInput.options = formData.idEstadoPaciente != 5 ? motivos : motivos.filter((x) => x.displayName == 'Suspension');
          break;
        case 'idEstadoPaciente':
          setFormData((previousData) => ({
            ...previousData,
            idMotivoAlta: 0
          }));
          if (evaluacionSelected?.idEstadoPaciente != ESTADO_PACIENTE_ALTA_ID) {
            updatedInput.options = estadoPaciente.filter((x) => x.displayName === 'Alta');
          } else if (evaluacionSelected?.idEstadoPaciente === ESTADO_PACIENTE_ALTA_ID) {
            updatedInput.options = estadoPaciente.filter((x) => x.displayName === 'Suspendido');
          } else {
            updatedInput.options = [{ id: -1, displayName: 'No hay opciones disponibles', disabled: true }];
          }
          break;
        default:
          break;
      }
      updatedInput.disabled = !allowedWrite;
      return updatedInput;
    });
  }, [motivoAlta, estadoPaciente, evaluacionSelected?.idEstadoPaciente, formData.idEstadoPaciente, allowedWrite]);

  return (
    <div className='generic-tab-container'>
            <Grid container spacing={3}>
 <Grid size={{ xs: 12 }}>
                    <div className='generic-header-tab-content-with-buttons'>
                        <strong>Cambio de estado paciente</strong>
                        <div className='button-save-geo-data'>
                            <CustomButton
                onClick={handleConsultar}
                label='Consultar'
                variant='outlined' />
              
                            <CustomButton
                sx={{ marginLeft: '10px' }}
                onClick={handleGrabar}
                disabled={!allowedWrite}
                label='Grabar'
                variant='outlined' />
              
                        </div>
                    </div>
                </Grid>
                {updatedFields.
        map((input, index) =>
        <Grid key={`input-${input.name}-index-${index}`} size={{ md: input.col, xs: input.type !== 'item' ? 12 : 0 }}>
                            <RenderInputByTypeMobile
            key={`input-${input.name}-index-${index}`}
            input={input}
            handleChange={handleChange}
            value={getValue(input.name)} />
          
                        </Grid>
        )}
            </Grid>
            <CustomDialog
        open={openModal}
        title='Listado de estado del paciente'
        onCancel={handleCloseModal}
        cancelText='Cerrar'
        fullWidth
        maxWidth='md'>
        
                <DataGridGenerico
          toolbar={false}
          columns={columns}
          rows={rows}
          totalCount={totalCount}
          loading={loadingHistorial} />
        
            </CustomDialog>
        </div>);

};

const useGetHistorial = (idPaciente) => {

  const [rows, setRows] = useState([]);

  const baseColumns = [
  {
    headerName: 'Estado',
    field: 'estado',
    flex: 1
  },
  {
    headerName: 'Motivo',
    field: 'motivo',
    flex: 1
  },
  {
    headerName: 'Observaciones',
    field: 'observacion',
    flex: 3
  },
  {
    headerName: 'Fecha',
    field: 'fechaEstado',
    type: 'date',
    time: false,
    flex: 1
  },
  {
    headerName: 'Fecha de cambio',
    field: 'fechaAlta',
    type: 'date',
    time: false,
    flex: 1
  },
  {
    headerName: 'Usuario',
    field: 'usuario',
    flex: 1
  }];


  const [getHistorialPaciente, { data: dataHistorialPaciente, loading: loadingHistorial }] = useLazyQuery(GET_PACIENTE_ESTADO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataHistorialPaciente) return;
    const adaptedHistoral = adaptPacienteEstadoArray(dataHistorialPaciente?.pacienteEstado);
    setRows(adaptedHistoral);
  }, [dataHistorialPaciente]);

  const columns = useMemo(() => generateColumnsDefaultConfiguration(baseColumns), [baseColumns]);
  const totalCount = useMemo(() => rows?.length || 0, [rows]);

  return {
    rows,
    columns,
    totalCount,
    loadingHistorial,
    getHistorialPaciente
  };
};

const fields = [
//row
{
  displayName: 'F. de cambio de estado',
  name: 'fechaEstado',
  type: 'date',
  disabled: false,
  col: 3
},
{
  displayName: 'Cambiar a',
  name: 'idEstadoPaciente',
  type: 'select',
  disabled: false,
  options: [],
  col: 3
},
{
  displayName: 'Motivo',
  name: 'idMotivoAlta',
  type: 'select',
  disabled: false,
  options: [],
  col: 2
},
//row
{
  displayName: "Observación",
  name: "observacion",
  type: "long_string",
  disabled: false,
  col: 12
}];